"use strict";
exports.__esModule = true;
exports.WALLET_PAYMENT_DETAILS = void 0;
exports.WALLET_PAYMENT_DETAILS = {
    FIRST_PAYMENT: {
        PAYMENT_DETAILS_HEADER: {
            ESTIMATED_PAYMENT_TITLE: 'Estimated payment',
            PAID_TITLE: 'Payment details'
        },
        ESTIMATE_DISCLAIMER: '👆 This payment is an estimate, and will be adjusted if your actual rent bill is higher or lower.',
        ESTIMATE_HIGHER_THAN_ACTUAL: '👆 Your rent bill was {{actualRentAmountHigher}} higher than estimated',
        ESTIMATE_LOWER_THAN_ACTUAL: '👆 Your rent bill was {{actualRentAmountLower}} lower than estimated',
        CHARGES_SECTION: {
            HEADER: 'Expected charges',
            FLEX_FUNDS: 'Flex Funds',
            FLEX_FUNDS_CTA: 'Manage funds',
            CHANGE_CARD_CTA: 'Change card'
        }
    },
    SECOND_PAYMENT: {
        MAKE_PAYMENT_CTA: 'Make payment'
    }
};
